import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.781}
    height={25.989}
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 8079 13304"
    {...props}
  >
    <path
      d="M1034 12537c270-60 644 70 840-78l805-571c75-23 2056-9 2289-9 96 0 380-14 452 9l806 571c195 148 570 18 840 78l-1 372-6021 6-10-378zm2794-8427 456-2 6 7506-456 5-6-7509zm2163 1975c24 22 454 698 464 817h-906c9-109 360-707 442-817zM2253 355l3592-4 1682 3458-6952 2L2253 355zM117 4104l3415 3c-1 178 26 7351-12 7513-273-2-579-12-849-2-126 5-140 39-284 144l-498 357c-91 65-156 146-301 150-277 8-566-14-843 0l-8 958 6602 3 5-957c-260-27-585 1-853-4-150-4-359-202-523-324-111-83-401-336-518-345-258-19-605 2-874 1l-8-7494 1294 1 2 1596c-5 123-13 80-70 156-56 75-116 200-170 289l-339 582c-28 83-19 354-8 449l1468-1c60-481-50-528-334-1021-47-82-120-224-170-288-48-62-74-45-82-146l2-1612 1821-5c-12-47-1839-3847-1954-4033H2072c-87 141-171 345-247 503-82 172-164 332-246 504-165 343-329 675-491 1013L117 4104z"
      style={{
        fill: "#010101",
        // stroke: "#000",
        strokeWidth: 147.43,
      }}
      className="fill"

    />
  </svg>
)
export default SvgComponent
